/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CloseInputs */

const th_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิด`)
};

const en_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const ja_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

const zh_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const es_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const pt_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const id_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup`)
};

const fr_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const tl_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isara`)
};

const vi_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng`)
};

const ko_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`닫기`)
};

const de_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const ru_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть`)
};

const tr_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapat`)
};

const it_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

const pl_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

const uk_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрити`)
};

const hi_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करें`)
};

const ar_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إغلاق`)
};

const ms_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup`)
};

const bn_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বন্ধ`)
};

const zh_tw2_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉`)
};

const zh_hk2_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉`)
};

const ur_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بند کریں`)
};

const fa_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بستن`)
};

const sw_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funga`)
};

const nl_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluiten`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {CloseInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const close = /** @type {((inputs?: CloseInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CloseInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_close(inputs)
	if (locale === "ja") return ja_close(inputs)
	if (locale === "zh") return zh_close(inputs)
	if (locale === "es") return es_close(inputs)
	if (locale === "pt") return pt_close(inputs)
	if (locale === "id") return id_close(inputs)
	if (locale === "fr") return fr_close(inputs)
	if (locale === "tl") return tl_close(inputs)
	if (locale === "vi") return vi_close(inputs)
	if (locale === "ko") return ko_close(inputs)
	if (locale === "de") return de_close(inputs)
	if (locale === "ru") return ru_close(inputs)
	if (locale === "tr") return tr_close(inputs)
	if (locale === "it") return it_close(inputs)
	if (locale === "pl") return pl_close(inputs)
	if (locale === "uk") return uk_close(inputs)
	if (locale === "hi") return hi_close(inputs)
	if (locale === "ar") return ar_close(inputs)
	if (locale === "ms") return ms_close(inputs)
	if (locale === "bn") return bn_close(inputs)
	if (locale === "zh-TW") return zh_tw2_close(inputs)
	if (locale === "zh-HK") return zh_hk2_close(inputs)
	if (locale === "ur") return ur_close(inputs)
	if (locale === "fa") return fa_close(inputs)
	if (locale === "sw") return sw_close(inputs)
	if (locale === "nl") return nl_close(inputs)
	return en_close(inputs)
});